import { render, staticRenderFns } from "./HelpGuide.vue?vue&type=template&id=618deb24"
import script from "./HelpGuide.vue?vue&type=script&lang=js"
export * from "./HelpGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports